import styled, { css } from "styled-components";

export const Container = styled.div`
  ${({ theme }) => css`
    width: 52%;
    max-width: 740px;
    height: 100%;
    margin-bottom: 50px;
    padding-left: 30px;
    padding-top: 20px;
    overflow: hidden;

    border-right: 1px solid ${theme.colors.background_light};
  `}
`;

export const ChecklistClick = styled.div`
  ${({ theme }) => css`
    text-decoration: underline;
    color: ${theme.colors.primary};
    cursor: pointer;
    font-size: 14px;
    margin-top: 10px;
  `}
`;

export const Top = styled.div`
  ${({ theme }) => css`
    margin-bottom: 30px;

    display: flex;
    align-items: center;

    h4 {
      font-size: ${theme.font.sizes.large};
      color: ${theme.colors.title};
      font-weight: ${theme.font.bold};
    }
  `}
`;

export const ButtonClose = styled.button`
  ${({ theme }) => css`
    width: 35px;
    height: 35px;
    background-color: ${theme.colors.background_light};
    border-radius: 10px;

    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 25px;
  `}
`;

export const WrapperInfoHeader = styled.div`
  ${({ theme }) => css`
    width: 92%;
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    & > div {
      display: flex;
      align-items: center;
      justify-content: space-between;

      & > div {
        width: 7px;
        height: 7px;
        border-radius: 50%;
        background-color: ${theme.colors.primary};
        margin-right: 6px;
      }
    }

    span {
      color: ${theme.colors.title};
      font-size: ${theme.font.sizes.xsmall};
    }
  `}
`;

export const Star = styled.img`
  width: 16px;
  height: 16px;
  margin-right: 4px;
`;

export const ButtonText = styled.span`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: ${theme.font.sizes.small};
    margin-left: 14px;

    &:hover {
      cursor: pointer;
      text-decoration: underline;
    }
  `}
`;

export const Content = styled.main`
  width: 92%;
  margin: 40px 0;

  & > div:not(#section-stages) {
    ${({ theme }) => css`
      margin-bottom: 30px;

      & > span {
        display: block;
        color: ${theme.colors.title};
        font-size: ${theme.font.sizes.xsmall};
        margin-bottom: 8px;
      }
    `}
  }
`;

export const ContentBoxTitle = styled.h4`
  ${({ theme }) => css`
    font-size: ${theme.font.sizes.xsmall};
    color: ${theme.colors.title};
    margin-bottom: 14px;
  `}
`;

export const ContentBoxText = styled.p`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: ${theme.font.sizes.xsmall};
    margin-top: 5px;
    white-space: pre-wrap;
  `}
`;

export const ContentBoxObservationText = styled.pre`
  ${({ theme }) => css`
    white-space: pre-wrap;
    color: ${theme.colors.text};
    font-size: ${theme.font.sizes.xsmall};
    margin-bottom: 4px;
    font-family: ${theme.font.family};
  `}
`;

export const WrapperRegisterDetails = styled.div`
  ${({ theme }) => css`
    margin-top: 16px;

    & > span {
      display: block;
      color: ${theme.colors.title};
      font-size: ${theme.font.sizes.xsmall};
      margin-bottom: 8px;
      margin-left: 5px;
    }

    & > div {
      margin-bottom: 10px;
    }
  `}
`;

export const Separator = styled.div`
  height: 1px;
  width: 100%;
  margin: 46px 0;
  background-color: #707070;
  opacity: 0.4;
`;

export const SectionStages = styled.div`
  margin-top: 20px;
  margin-bottom: 30px;

  & > span {
    ${({ theme }) => css`
      display: block;
      margin-bottom: 18px;
      color: ${theme.colors.title};
      font-weight: ${theme.font.bold};
      font-size: ${theme.font.sizes.small};
    `}
  }
`;

export const WrapperButton = styled.div`
  margin-top: 20px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;

  & > span {
    ${({ theme }) => css`
      color: ${theme.colors.text};
      font-size: ${theme.font.sizes.small};
    `}
  }
`;

export const Footer = styled.div`
  margin-top: 30px;
  width: 100px;
`;

export const LinkDownloadPdf = styled.a`
  text-decoration: none;
`;

export const WrapperSignature = styled.div`
  ${({ theme }) => css`
    margin-top: 10px;
  `}
`;

export const ObservationButton = styled.button`
  ${({ theme }) => css`
    color: ${theme.colors.text};
    font-size: 12px;
    text-decoration: underline;
  `}
`;
